export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfABc4AMP6lbBP.9449f537.woff2";